"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
var PortalContext = /*#__PURE__*/(0, _react.createContext)({
  getPortalContainer: function getPortalContainer() {
    if (typeof document === 'undefined') {
      return null;
    }

    // eslint-disable-next-line compat/compat
    return document.body;
  }
});
var _default = PortalContext;
exports.default = _default;